<app-upload-contract-button [dealId]="dealId"></app-upload-contract-button>